var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.431 3.72167C13.8721 3.21333 14.2083 2.62287 14.4206 1.98419C14.6328 1.34552 14.7168 0.671216 14.6677 0C13.3136 0.109301 12.0567 0.746149 11.1677 1.77333C10.7419 2.26564 10.4193 2.83836 10.2189 3.45758C10.0185 4.07681 9.94443 4.72995 10.001 5.37833C10.6615 5.38384 11.3144 5.23728 11.9092 4.95C12.504 4.66272 13.0247 4.24244 13.431 3.72167ZM16.371 12.4017C16.3788 11.5077 16.6143 10.6305 17.0552 9.85274C17.4961 9.07502 18.1279 8.42247 18.891 7.95667C18.4094 7.26278 17.7728 6.69064 17.0316 6.28562C16.2904 5.8806 15.4651 5.65384 14.621 5.62333C12.801 5.43667 11.121 6.685 10.1527 6.685C9.18433 6.685 7.81933 5.64667 6.30266 5.67C5.31115 5.70266 4.34502 5.99174 3.49852 6.50905C2.65201 7.02636 1.95404 7.75423 1.47266 8.62167C-0.580671 12.1917 0.947662 17.5 3.001 20.3817C3.93433 21.7933 5.101 23.3917 6.641 23.3333C8.181 23.275 8.68266 22.3767 10.4677 22.3767C12.2527 22.3767 12.801 23.3333 14.3177 23.2983C15.8343 23.2633 16.9077 21.8517 17.8877 20.44C18.5819 19.4151 19.1242 18.2952 19.4977 17.115C18.5731 16.7207 17.7842 16.0642 17.2285 15.2265C16.6729 14.3889 16.3748 13.4068 16.371 12.4017Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleLogo);
export default __webpack_public_path__ + "static/media/apple-logo.9868a7ba7fd6f1677e7017be54b5b4d4.svg";
export { ForwardRef as ReactComponent };